export default __webpack_public_path__ + "static/28d-card-bg-f10a784bc811228da2b3eed214685ecd.png";